import React, {useContext} from 'react'
import { useParams } from 'react-router-dom'
import OrgPatientListStore from '../../../components/Modals/PrintModal/store/OrgPatientListStore'
import { observer } from 'mobx-react'
import PatientListPageTemplate from '../../../components/Templates/PatientListPageTemplate'
import {AuthContext} from "../../../context/AuthContext";
import TextCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {formatDate, isWaiting} from "../../../utils/utils";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";

const OrgPatientList = observer(() => {

  const { medId, orgId, orgName, history, historyId } = useParams()
  const { REACT_APP_URL_PREFIX } = process.env
const userId = useContext(AuthContext)?.token?.userId
  return (
    <PatientListPageTemplate
      getPatientURL={`/api/v2/verificationCenters/${userId}/medCenters/${medId}/organizations/${orgId}/histories/${historyId}/patients?`}
      exportUrl={`/api/v2/general/export/excel?historyId=${historyId}&`}
      registry={`/api/v2/general/export/registry/?historyId=${historyId}&`}
      tableModel={tableModel}
	  printall={true}
      filterFieldsConf={{
          fio: true,
          date: true,
          period: true,
          org: true,
          medBook: true,
          center: true,
          result: true,
      }}
	  printall={true}
      breadCrumbsItems={[
        { title: 'Контрагенты', link: REACT_APP_URL_PREFIX + '/counterAgents/MedCenterList' },
        { title: orgName, link: REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}` },
        {
          title: history,
          link: REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}/organizations/${orgId}/${history}`
        },
        {
          title: 'Пациенты',
          actual: true,
          link: REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}/${orgId}/${history}/${historyId}`
        }
      ]}
    />


  )
})

export default OrgPatientList

var tableModel = {
  firstRow:
    [
      { title: 'ФИО', id: 'fio' },
      { title: 'Дата рождения', id: 'dob' },
      { title: 'Мед. книжка', id: 'med_book' },
      { title: 'Дата прохождения', id: 'result_date' },
      { title: 'Результат', id: 'result' },
      { title: 'Распечатать', id: '' }
    ],
  haveToShow: [
    { id: 'patient_info', type: 'arrCell', typeData: { show: 'fio', id: 'id' } },
    { id: 'patient_info', type: 'arrCell', typeData: { show: 'dob', id: 'id' } },
    { id: 'patient_info', type: 'arrCell', typeData: { show: 'med_book', id: 'id' } },
    { id: 'result_date', type: "wrapperCell", typeData: {cell: props => <TextCell text={formatDate(props.cellContent)}/>} },
    { id: 'result', type: 'resultStatusCell', typeData: { show: 'result', id: 'id' } },
      {
          id: 'results',
          typeData: {
              cell: props =>  !isWaiting(props.all?.result) ? <IconCell iconName={"printer"} onClick={() => OrgPatientListStore.showPrintModal( props.all.id, props.all?.patient_info?.id,  )}/> : "",
          },
          type: 'wrapperCell'
      }
  ]
}
